import { Coins } from '../Coins';
import { PublicKey } from '../PublicKey';
import { JSONSerializable } from '../../util/json';
import { AccAddress } from '../strings';

export class Account extends JSONSerializable<Account.Data> {
  constructor(
    public address: AccAddress,
    public coins: Coins,
    public public_key: PublicKey | null,
    public account_number: number,
    public sequence: number
  ) {
    super();
  }

  public toData(): Account.Data {
    const { address, coins, public_key, account_number, sequence } = this;
    return {
      type: 'core/Account',
      value: {
        address,
        coins: coins.toData(),
        public_key: public_key ? public_key.toData() : null,
        account_number: account_number.toFixed(),
        sequence: sequence.toFixed(),
      },
    };
  }

  public static fromData(data: Account.Data): Account {
    const {
      value: { address, coins, public_key, account_number, sequence },
    } = data;

    return new Account(
      address,
      Coins.fromData(coins),
      public_key ? PublicKey.fromData(public_key) : null,
      Number.parseInt(account_number),
      Number.parseInt(sequence)
    );
  }
}

export namespace Account {
  export interface Value {
    address: AccAddress;
    coins: Coins.Data;
    public_key: PublicKey.Data | null;
    account_number: string;
    sequence: string;
  }

  export interface Data {
    type: 'core/Account';
    value: Value;
  }
}
